import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreTypes } from '../storeTypes.enum';
import { GroupTasksEffects } from './effects';
import { reducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [StoreModule.forFeature(StoreTypes.GroupAction, reducer), EffectsModule.forFeature([GroupTasksEffects])],
  exports: []
})
export class RmmGroupTasksStoreModule {}
